export default __webpack_public_path__ + "static/media/Boat1.c78ca943.svg";